export enum CandidateFileType {
  Cv = 'cv',
  User = 'user',
  Anonymous = 'anonymous',
  DetailedCv = 'detailed_cv',
  MiniCv = 'mini_cv',
  Merged = 'merged',
  CoverLetter = 'cover_letter',
  Document = 'document',
  EmploymentReferences = 'employment_references',
  Training = 'training',
  OtherDocuments = 'other_documents',
}

export const CANDIDATE_FILE_TYPE_I18N: Record<CandidateFileType, string> = {
  [CandidateFileType.Anonymous]: 'Interne Dokumente',
  [CandidateFileType.Cv]: 'Lebenslauf',
  [CandidateFileType.Merged]: 'Merged',
  [CandidateFileType.DetailedCv]: 'Detailed CV',
  [CandidateFileType.MiniCv]: 'Mini CV',
  [CandidateFileType.User]: 'Zusätzliche Zertifikat',
  [CandidateFileType.CoverLetter]: 'Anschreiben',
  [CandidateFileType.Document]: 'Urkunde',
  [CandidateFileType.EmploymentReferences]: 'Arbeitszeugnisse',
  [CandidateFileType.Training]: 'Weiterbildungen',
  [CandidateFileType.OtherDocuments]: 'Andere Dokumente',
};

export const GENERATED_CANDIDATE_FILE_TYPES = [CandidateFileType.DetailedCv, CandidateFileType.MiniCv];

export const NON_CV_FILE_TYPES_VISIBLE_TO_CANDIDATE = [
  CandidateFileType.User,
  CandidateFileType.Document,
  CandidateFileType.EmploymentReferences,
  CandidateFileType.Training,
  CandidateFileType.OtherDocuments,
];

export const FILE_TYPES_VISIBLE_TO_CANDIDATE = [CandidateFileType.Cv, ...NON_CV_FILE_TYPES_VISIBLE_TO_CANDIDATE];

export const CV_FILE_TYPES_VISIBLE_TO_CANDIDATE = [CandidateFileType.Cv, CandidateFileType.DetailedCv];

export const FILE_TYPES_FOR_HAS_CV_CHECK = [CandidateFileType.Cv, CandidateFileType.DetailedCv, CandidateFileType.MiniCv];

export const SEND_FILE_TYPE_ORDER: CandidateFileType[] = [
  CandidateFileType.CoverLetter,
  CandidateFileType.DetailedCv,
  CandidateFileType.MiniCv,
  CandidateFileType.Cv,
  CandidateFileType.Document,
  CandidateFileType.Training,
  CandidateFileType.User,
  CandidateFileType.EmploymentReferences,
  CandidateFileType.OtherDocuments,
];

export const AUTO_MERGE_FILE_TYPES: CandidateFileType[] = [
  CandidateFileType.CoverLetter,
  CandidateFileType.DetailedCv,
  CandidateFileType.Document,
  CandidateFileType.Training,
  CandidateFileType.User,
  CandidateFileType.EmploymentReferences,
];
